var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcCatalogueGridTileIcon = function SvgIcCatalogueGridTileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-27c1.497 0 2.993.278 4.411.833l3.405 1.333A472.962 472.962 0 0 0 180.252 7.721h30.899a6.386 6.386 0 0 1 6.387 6.386v27",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 105.548)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-23.666a7.296 7.296 0 0 1-7.295-7.297v-270.022a7.295 7.295 0 0 1 7.295-7.296h35.295a540.286 540.286 0 0 0 196.981-37.189l2.853-1.117a16.66 16.66 0 0 1 6.076-1.146v28.804",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(38.461 373.81)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.062 0 4.122.382 6.075 1.146l2.854 1.118a540.28 540.28 0 0 0 196.98 37.188h35.295a7.297 7.297 0 0 1 7.296 7.296v270.023a7.296 7.296 0 0 1-7.296 7.296h-23.666",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 49.743)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-68.926c0-1.016.732-1.881 1.734-2.053A504.597 504.597 0 0 0 58.593-84.13a2.085 2.085 0 0 1 2.677 1.999v68.437c0 .923-.604 1.74-1.487 2.007A491.434 491.434 0 0 1 2.458 2.066 2.097 2.097 0 0 1 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(159.73 238.998)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-14.289c0-1.154.936-2.084 2.09-2.083a521.878 521.878 0 0 0 56.866-3.055 2.083 2.083 0 0 1 2.313 2.071v68.512a2.097 2.097 0 0 1-1.821 2.081 439.185 439.185 0 0 1-57.162 3.72h-.195A2.091 2.091 0 0 1 0 54.866V35",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(73.461 289.99)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a496.737 496.737 0 0 1-57.318 3.266 2.101 2.101 0 0 1-2.096-2.1v-69.155c0-1.156.937-2.092 2.092-2.092h.194c19.021 0 37.924-1.051 56.664-3.145a2.083 2.083 0 0 1 2.319 2.071v69.069A2.1 2.1 0 0 1 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(132.875 245.35)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-68.926a2.083 2.083 0 0 0-1.734-2.053 504.665 504.665 0 0 1-56.86-13.151 2.085 2.085 0 0 0-2.676 1.999v68.437c0 .923.604 1.74 1.487 2.007A491.434 491.434 0 0 0-2.458 2.066 2.097 2.097 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(352.27 238.998)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v68.513c0 1.051.779 1.944 1.821 2.081a439.371 439.371 0 0 0 57.162 3.719h.195a2.09 2.09 0 0 0 2.091-2.09V3.067a2.084 2.084 0 0 0-2.09-2.083A521.878 521.878 0 0 1 2.313-2.07 2.082 2.082 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(377.27 272.633)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a496.724 496.724 0 0 0 57.318 3.266 2.1 2.1 0 0 0 2.095-2.1v-69.155a2.09 2.09 0 0 0-2.091-2.092h-.194A510.014 510.014 0 0 1 .465-73.226a2.084 2.084 0 0 0-2.32 2.071v69.069C-1.855-1.021-1.058-.122 0 0z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(379.125 245.35)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.998 5.998 0 0 1-2.193 2.193l-70.423 40.659a5.99 5.99 0 0 1-5.993 0l-70.422-40.659A5.993 5.993 0 0 1-151.225 0l75.613-43.654z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(331.612 418.603)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-87.31c1.034 0 2.069.268 2.996.803l70.423 40.658a5.996 5.996 0 0 1 2.996 5.191v81.316a5.98 5.98 0 0 1-.803 2.996",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 374.948)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.992 5.992 0 0 1-.803-2.996v-81.317a5.991 5.991 0 0 1 2.997-5.19l70.422-40.658a5.992 5.992 0 0 1 2.996-.803",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(180.388 418.603)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 14.721 8.499",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(287.791 364.435)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v174.681a6.386 6.386 0 0 1-6.387 6.387h-30.898a472.92 472.92 0 0 1-103.838-11.54",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(473.538 200.879)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.497 0 2.994.277 4.413.833l3.401 1.332A472.982 472.982 0 0 0 180.253 34.72h30.898a6.386 6.386 0 0 1 6.387 6.386V60.33",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 105.549)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v28.031",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 259.607)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a472.98 472.98 0 0 1-103.838 11.54h-30.898a6.387 6.387 0 0 1-6.388-6.388v-228.904a6.388 6.388 0 0 1 6.388-6.387h30.898A472.989 472.989 0 0 0 68.6-262.693l3.402-1.332a12.089 12.089 0 0 1 4.413-.833V-145.8",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(179.585 370.407)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v.195a433.86 433.86 0 0 1-17.348 3.868 2.098 2.098 0 0 1-2.506-2.058v-67.682c0-1.02.736-1.886 1.743-2.054a516.36 516.36 0 0 0 56.863-12.834 2.084 2.084 0 0 1 2.663 2.002v51.192",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(179.585 334.29)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-51.192a2.084 2.084 0 0 1 2.663-2.002A516.308 516.308 0 0 0 59.526-40.36a2.082 2.082 0 0 1 1.744 2.054v67.682a2.1 2.1 0 0 1-2.507 2.059 436.015 436.015 0 0 1-17.348-3.869v-.195",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(291 306.919)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-27a6.388 6.388 0 0 1 6.387-6.387h30.9a472.973 472.973 0 0 0 172.435-32.554l3.405-1.333a12.104 12.104 0 0 1 4.412-.833",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(38.461 146.655)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCatalogueGridTileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_catalogue_grid_tile_icon.a583b9ff.svg";
export { ForwardRef as ReactComponent };